import { z } from 'zod';
import { propertyRentProfileSchema, } from './rentRadar.js';
export const ESTIMATE_INPUT_FACTORS = [
    'propertyAge',
    'buildingUpkeep',
    'poolRecRoom',
    'grounds',
];
function knownFacts({ yearBuilt, profile }) {
    return {
        propertyAge: yearBuilt !== undefined && yearBuilt !== null,
        buildingUpkeep: profile.upkeep !== undefined,
        poolRecRoom: profile.recRoom !== undefined,
        grounds: profile.groundsKept !== undefined,
    };
}
export function estimateInputGaps(facts) {
    const known = knownFacts(facts);
    return ESTIMATE_INPUT_FACTORS.filter((factor) => !known[factor]);
}
export function effectiveEstimateParameters(input) {
    const known = knownFacts(input);
    const effective = { ...input.parameters };
    for (const factor of ESTIMATE_INPUT_FACTORS) {
        effective[factor] = input.parameters[factor] && known[factor];
    }
    return effective;
}
export const estimateInputsSnapshotSchema = z.object({
    yearBuilt: z.number().int().optional(),
    propertyProfile: propertyRentProfileSchema,
});
//# sourceMappingURL=rentRadarInputs.js.map